var PatternForm = {
    /**
     * comentar
     * @param campo
     * @param contador
     * @param limite
     */
    'counter': function (campo, contador, limite) {
        var objCampo = jQuery('#' + campo);
        var objContador = jQuery('#' + contador);
        var intCaracteres = objCampo.val().length;

        if (intCaracteres > limite) {
            objCampo.val(objCampo.val().substr(0, limite));
        } else {
            objContador.html(intCaracteres);
        }
    },

    /**
     * Controla inputs de texto e password em eventos de focus, blur e change
     *
     * @param event
     * @param value
     */
    'ManageInput': {
        'focus' : function(element, defaultValue) {
            var $element = jQuery(element),
                    jqLabelSelector = 'label[for="' + $element.attr('id') + '"]',
                    $label = jQuery(jqLabelSelector),
                    $hint = jQuery('#' + $element.attr('id') + '_hint'),
                    $otherHints = jQuery('.tooltip_hint');

            $element.addClass('active');
            $label.addClass('active');

            $otherHints.hide();
            $hint.fadeIn('fast');

            if ($element.attr('type').toLowerCase() === 'text' && $element.val() == defaultValue) {
                $element.val('');
            }
        },
        'blur' : function(element, defaultValue) {
            var $element = jQuery(element),
                    jqLabelSelector = 'label[for="' + $element.attr('id') + '"]',
                    $label = jQuery(jqLabelSelector),
                    $hint = jQuery('#' + $element.attr('id') + '_hint'),
                    $otherHints = jQuery('.tooltip_hint');

            $element.removeClass('active');
            $label.removeClass('active');
            //setTimeout(function() { $hint.hide(); }, 300);
            $hint.fadeOut('slow');

            if ($element.val() === '') {
                if ($element.is(':password')) {
                    $element.addClass(defaultValue);
                } else {
                    $element.val(defaultValue);
                }
            } else if ( $element.is(':password') ) {
                $element.removeClass('label');
            }
        },
        'change' : function(element, defaultValue) {
            var $element = jQuery(element),
                    $parent = $element.parent();

            $parent.removeClass('alert_field');
        }
    },

    /**
     * controla selects
     * @param element
     */
    'ManageSelect' : {
        'focus' : function (element) {
            var $select = jQuery(element),
                    $label = jQuery('label[for=' + $select.attr('id') + ']'),
                    $hint = jQuery('#' + $select.attr('id') + '_hint'),
                    $otherHints = jQuery('.tooltip_hint');

            $select.addClass('active');
            $label.addClass('active');

            $otherHints.hide();
            $hint.fadeIn('fast');
        },
        'blur' : function(element) {
            var $select = jQuery(element),
                    $label = jQuery('label[for=' + $select.attr('id') + ']'),
                    $hint = jQuery('#' + $select.attr('id') + '_hint'),
                    $otherHints = jQuery('.tooltip_hint');

            $select.removeClass('active');
            $label.removeClass('active');
            $hint.fadeOut('slow');
        },
        'change' : function(element) {
            var $select = jQuery(element);
            $select.parent().removeClass('alert_field');
        }
    },

    /**
     * $Pattern->selectDate, $Pattern->selectTime
     */
    'ManageCombinedSelect': {
        /**
         *
         * @param element
         * @param event
         * @param id
         */
        'focus' : function(element, event, id) {
            var $parent = jQuery(element).parent(),
                    $selects = $parent.find('select'),
                    $label = jQuery('label[for=' + $selects.first().attr('id') + ']'),
                    $hint = jQuery('#' + id + '_hint'),
                    $hints = jQuery('.tooltip_hint');
            $label.addClass('active');
            $selects.addClass('active');
            $hints.hide();
            $hint.fadeIn('slow');
        },
        /**
         *
         * @param element
         * @param event
         * @param id
         */
        'blur' : function(element, event, id) {
            var $parent = jQuery(element).parent(),
                    $selects = $parent.find('select'),
                    $label = jQuery('label[for=' + $selects.first().attr('id') + ']'),
                    $hint = jQuery('#' + id + '_hint'),
                    $hints = jQuery('.tooltip_hint');
            $label.removeClass('active');
            $selects.removeClass('active');
            $hint.fadeOut('slow');
        },
        /**
         *
         * @param element
         * @param event
         * @param id
         * @param type
         */
        'change' : function(element, event, id, type) {
            var $parent = jQuery(element).parent(),
                    $selects = $parent.find('select'),
                    $label = jQuery('label[for=' + $selects.first().attr('id') + ']'),
                    $hint = jQuery('#' + id + '_hint'),
                    $hints = jQuery('.tooltip_hint'),
                    $hidden = jQuery('#' + $parent.attr('id').split('_')[0]),
                    HiddenValue = new Array();

            $selects.each(function() {
                HiddenValue.push(jQuery(this).val());
            });

            if (type == 'time') {
                HiddenValue = HiddenValue.join('');
            } else if (type == 'date') {
                HiddenValue.reverse();
                HiddenValue = HiddenValue.join('');
            }
            $hidden.val(HiddenValue);

            $parent.removeClass('alert_field');
        }
    },

    'autocomplete': {

        'list' : {},

        'loadList' : function(term,inputName,classPHP,classMethodPHP,message){

           if ( term in PatternForm.autocomplete.list ) {

               return PatternForm.autocomplete.list[term];

           }else{

               var list = {},
                   dados = inputName + '=' + term;

                enable_load = false;
                list = SendDataByAjaxRunMethodSync(dados, classPHP, classMethodPHP);
                enable_load = true;

                if( list == false ){

                    jQuery('#feedback_'+inputName).addClass('alert_inline');
                    jQuery('#feedback_'+inputName).html(message);

                    return "";

                }else{

                    jQuery('#feedback_'+inputName).removeClass('alert_inline');
                    jQuery('#feedback_'+inputName).html('');

                    PatternForm.autocomplete.setList(list, term);

                    return PatternForm.autocompleteOfCities.list[term];
                }

           }

        },

        'setList' : function(list,term) {
           PatternForm.autocomplete.list[term] = list;
        }

    },

    'autocompleteOfCities': {
        'enablePositionCity': 0,

        'list': {},

        'loadList': function (term, inputName, elementName) {
            if (term in PatternForm.autocompleteOfCities.list) {
                return PatternForm.autocompleteOfCities.list[term];
            } else {
                var list,
                    dados = 'enablePositionCity=' + PatternForm.autocompleteOfCities.enablePositionCity + '&' + inputName + '=' + term + ' ';

                enable_load = false;
                list = SendDataByAjaxRunMethodSync(dados, 'City', 'getAutoCompleteCityList');
                enable_load = true;

                if (list == false) {
                    // jQuery('#feedback_'+inputName).addClass('alert_inline');
                    // jQuery('#feedback_'+inputName).html('<p class="nomargin">Cidade não encontrada. Envie um email para '+jQuery('#emailFeedBackAlert').val()+' para que possamos incluí-la.</p>');
                    return "";
                } else {
                    jQuery('#feedback_' + inputName).removeClass('alert_inline');
                    jQuery('#feedback_' + inputName).html('');

                    PatternForm.autocompleteOfCities.setList(list, term);

                    return PatternForm.autocompleteOfCities.list[term];
                }
            }
        },

        'setList': function (list, term) {
            PatternForm.autocompleteOfCities.list[term] = list;
        },

        'clean': function (elementName, inputName) {
            PatternForm.autocompleteOfCities.list = [];
            jQuery('#feedback_' + inputName).removeClass('alert_inline');
            jQuery('#feedback_' + inputName).html('');
            jQuery('#txPsrOndeNasceu' + elementName).val("");
            jQuery('#ddCity' + elementName).val("");
            jQuery('#ddEstate' + elementName).val("");
            jQuery('#ddCountry' + elementName).val("");
        },

        'checkValue': function (elementName) {

            if (jQuery('#txPsrOndeNasceu' + elementName).val() && jQuery('#ddCity' + elementName).val() && jQuery('#ddEstate' + elementName).val() && jQuery('#ddCountry' + elementName).val()) {
                return true;
            } else {
                return false;
            }

        },

        'setCityData': function (elementName, cityID, estateID, countryID) {
            PatternForm.autocompleteOfCities.list = [];
            jQuery('#ddCity' + elementName).val(cityID);
            jQuery('#ddEstate' + elementName).val(estateID);
            jQuery('#ddCountry' + elementName).val(countryID);
        }


    }

};

var PatternControler = {
    'ManageTextZoom': function(event, content) {
        var $control = jQuery(event.target),
                action = $control.attr('id').split('_'),
                $content = jQuery(content),
                actualSize = $content.css('fontSize');

        action = action.pop();
        event.preventDefault();

        switch (action) {
            case 'in':
                switch (actualSize) {
                    case '8px':
                        $content.css({'fontSize' : '10px'});
                        break;
                    case '10px':
                        $content.css({'fontSize' : '12px'});
                        break;
                    case '100%':
                        $content.css({'fontSize' : '14px'});
                        break;
                    case '12px':
                        $content.css({'fontSize' : '14px'});
                        break;
                    case '14px':
                        $content.css({'fontSize' : '16px'});
                        break;
                    case '16px':
                        $content.css({'fontSize' : '18px'});
                        break;
                }
                break;
            case 'out':
                switch (actualSize) {
                    case '10px':
                        $content.css({'fontSize' : '8px'});
                        break;
                    case '100%':
                        $content.css({'fontSize' : '10px'});
                        break;
                    case '12px':
                        $content.css({'fontSize' : '10px'});
                        break;
                    case '14px':
                        $content.css({'fontSize' : '12px'});
                        break;
                    case '16px':
                        $content.css({'fontSize' : '14px'});
                        break;
                    case '18px':
                        $content.css({'fontSize' : '16px'});
                        break;
                }
                break;
        }
    },

    //$Pattern->Controler->TabBrowser
    'ManageTabBrowser': function(event) {
        var $tab = jQuery(event.target),
                number = 0,
                $tabs = jQuery('[id^="tab_browser_"]');

        event.preventDefault();

        if (!$tabs.length) {
            return;
        }

        $tabs.each(function() {
            var $this = jQuery(this),
                    number = 0;
            $this.removeClass('active');

            number = $this.attr('id').split('_');

            jQuery('#content_tab_' + number.pop()).hide();
        });

        $tab.addClass('active');

        number = $tab.attr('id').split('_');

        jQuery('#content_tab_' + number.pop()).show();
    },

    //$Pattern->Controler->Folder
    /**
     *
     * @param event
     * @param content
     * @param expanded
     */
    'ManageFolder': function(event, content, expanded) {
        var $content = jQuery('#' + content),
                $control = jQuery(event.target);
        event.preventDefault();

        if (event.type == 'load') {
            if ($content.length) {
                var $list = $content.parent();
                if (expanded) {
                    $content.show();
                    $list.addClass('active');
                } else {
                    $content.hide();
                    $list.removeClass('active');
                }
            }
        } else {
            if ($control.is('span')) {
                $control = $control.parent();
            }
            var $list = $control.parent();
            if ($control.attr('id').split('_')[1] === 'icon') {
                $control = $control.parent();
            }

            if ($control.hasClass('expand')) {
                PatternControler.clearFolder('expand', $control, content);

                $content.toggle();
                $control.removeClass('expand')
                        .addClass('collapse');
                $list.addClass('active');

            } else if ($control.hasClass('collapse')) {
                $content.toggle();

                $control.removeClass('collapse')
                        .addClass('expand');
                $list.removeClass('active');
            }

        }

        jQuery('a.collapse span.off').text('-');
        jQuery('a.expand span.off').text('+');
    },

    /**
     *
     * @param action
     * @param $control
     * @param content
     */
    'clearFolder': function (action, $control, content) {
        switch (action) {
            case 'expand':
                var UL = $control.parent().parent();
                var $opened = jQuery('a[class~=collapse]');

                if (!$opened.length) {
                    return;
                }

                $opened = $opened.first();
                var $list = $opened.parent();
                var openedContentID = $opened.attr('id').split('_');

                openedContentID[openedContentID.length - 2] = 'content';
                openedContentID = openedContentID.join('_');

                $opened.removeClass('collapse');
                $opened.addClass('expand');
                $list.removeClass('active');

                jQuery('#' + openedContentID).hide();
                break;
        }
    }
};

/**
 *
 */
var PatternLayout = {
    /**
     *
     * @param event
     * @param listID
     */
    'ManageFeatureList': function (event, listID) {
        var $List = jQuery('#' + listID);
        var $LIs = $List.find('li');

        $LIs.first().addClass('activeFeature');

        $LIs.hide();

        if ($LIs.length > 1) {
            setInterval(function () {
                var $active = $List.find('.activeFeature').first();
                var $next = $active.next();

                if (!$next.length) {
                    $next = $LIs.first();
                }

                $active.hide()
                        .removeClass('activeFeature');
                $next.show()
                        .addClass('activeFeature');

            }, 3000);
        }
    }
};

function ToolTipRemove(event, hint) {
    var $tEl = jQuery(event.target);

    if (!$tEl.parent().hasClass('tooltip_hint')) {
        if (hint != null) {
            hint.fadeOut();
            jQuery(document).unbind('click', ToolTipRemove);
        }
    }
}

function showContent(contentID) {
    switch (contentID) {
        case '1':
            jQuery('#tab_1').addClass('active');
            jQuery('#content_1').show();
            jQuery('#tab_2').removeClass('active');
            jQuery('#content_2').hide();

            break;
        case '2':
            jQuery('#tab_2').addClass('active');
            jQuery('#content_2').show();
            jQuery('#tab_1').removeClass('active');
            jQuery('#content_1').hide();
            break;
    }
}

function searchTemplatePattern(event, id, formID, template, divUpdate) {
    var divUp;
    if (id != '' || typeof(id) != 'undefined') {
        divUp = divUpdate + id;
    } else {
        divUp = divUpdate;
    }
    var data = 'id=' + id + '&' + formID + '=' + id;
    //var template = template;
    contents = jQuery('#' + divUp).html();

    if (contents == '') {
        SendDataByAjaxRunTemplate(template, data, function(content) {
            jQuery(divUp).html(content);
        });
    } else {
        jQuery(divUp).html('');
    }

}

/***********************************************
 * Pattern para slide com scrool na horizontal
 *
 *
 ***/
var NEFSlide = {
    'totalSlides' : 0,
    'currentSlide' : 0,
    'contentSlides' : "",
    'element' : "",
    'totalElementsToSlide' : 1,
    'totalWidth' : 0,
    'isLastElement' : false,
    'refreshWithAjax' : false,
    'initSlideOrder' : 'DESC',
    'ajaxLimitList' : 20,
    'start': function (element) {
        NEFSlide.currentSlide = 0;
        NEFSlide.element = '.slideshow-content';
        jQuery("#slideshow-scroller").attr({scrollLeft: 0});
        jQuery("#slideshow-holder").css('width', 0);
        NEFSlide.setTotalWidth();
        jQuery("#slideshow-previous").bind('click',NEFSlide.showPreviousSlide);
        jQuery("#slideshow-next").bind('click',NEFSlide.showNextSlide);
    },
    'setTotalWidth' : function(){
        NEFSlide.contentSlides = jQuery('.slideshow-content');
        NEFSlide.totalWidth = 0;
        NEFSlide.totalSlides = 0;
        var leftAux = 30;
        NEFSlide.contentSlides.each(function(i){
        	if(jQuery(this).find('span').hasClass('same-month')){
            	leftAux += 20;
            }else if(jQuery(this).find('span').hasClass('same-year')){
            	leftAux += 30;
            }else if(jQuery(this).find('span').hasClass('different-year')){
            	leftAux += 40;
            }
        	jQuery(this).css('left',leftAux);
            leftAux += 80;
        });

        NEFSlide.totalSlides = jQuery(".slideshow-content").length;
        var elementWidth = jQuery(".slideshow-content").innerWidth() + parseInt(jQuery('.slideshow-content').css('border-left-width')) + parseInt(jQuery('.slideshow-content').css('border-right-width'));
        NEFSlide.totalWidth = (NEFSlide.totalSlides * elementWidth);
        jQuery("#slideshow-holder").css( "width",NEFSlide.totalWidth);
    },
    'showPreviousSlide' : function(){
        NEFSlide.isLastElement = false;
        NEFSlide.currentSlide-=NEFSlide.totalElementsToSlide;
        NEFSlide.updateContentHolder();
        NEFSlide.updateButtons();
    },
    'showNextSlide' : function(){
        NEFSlide.currentSlide+=NEFSlide.totalElementsToSlide;
        NEFSlide.updateContentHolder();
        NEFSlide.updateButtons();
    },
    'checkLoadMoreList' : function(){
        if(NEFSlide.currentSlide >= NEFSlide.totalSlides){
            if( NEFSlide.refreshWithAjax === true){
                NEFSlide.loadMoreList();
            }else{
                NEFSlide.loadLastItem();
            }
        }else if( (NEFSlide.totalSlides - NEFSlide.currentSlide) == 1){
            NEFSlide.currentSlide = NEFSlide.totalSlides - 1;
            NEFSlide.loadLastItem();
        }
    },
    'loadLastItem' : function(){
        NEFSlide.isLastElement = true;
        NEFSlide.refreshWithAjax = false;
        jQuery("#slideshow-next").hide();
    },
    'updateContentHolder' : function(){
        var scrollAmount = 0;
        NEFSlide.checkLoadMoreList();
        if( NEFSlide.isLastElement ){
            NEFSlide.loadLastItem();
            jQuery("#slideshow-scroller").animate({scrollLeft: jQuery('#slideshow-holder').innerWidth() }, 500);
        }else{
            scrollAmount += jQuery(NEFSlide.element).last().innerWidth() * NEFSlide.currentSlide;
            jQuery("#slideshow-scroller").animate({scrollLeft: scrollAmount}, 500);
        }
    },
    'updateButtons' : function(){
        if(NEFSlide.currentSlide > 1) {
            jQuery("#slideshow-previous").show();
        } else {
            jQuery("#slideshow-previous").hide();
        }
        if(NEFSlide.isLastElement){
            jQuery("#slideshow-next").hide();
        }else if(NEFSlide.currentSlide < NEFSlide.totalSlides) {
            jQuery("#slideshow-next").show();
        } else {
            jQuery("#slideshow-next").hide();
        }
    },
    'loadMoreList' : function(){
        if( jQuery(NEFSlide.element).last().hasClass('end-list') === false){
            var data = 'lastID='+jQuery(NEFSlide.element).last().attr('data-id')+'&order='+NEFSlide.initSlideOrder+'&startLimit='+NEFSlide.ajaxLimitList;
            var html = SendDataByAjaxRunMethodSync(data, 'CreatedProduct', 'ajaxListLastCreatedProduct');
            escondeLoader();
            if(html == false){
                NEFSlide.loadLastItem();
                NEFSlide.setTotalWidth();
                if(NEFSlide.totalSlides < 5){
                    jQuery("#slideshow-previous").hide();
                }else{
                    NEFSlide.currentSlide = NEFSlide.totalSlides - 1;
                }
            }else{
                jQuery('#slideshow-holder').append(html);
                NEFSlide.setTotalWidth();
                //NEFSlide.currentSlide += NEFSlide.totalElementsToSlide;
                jQuery("#slideshow-next").show();
            }
        }
    }
};
